import React, { useCallback } from "react";
import { Form, Segment } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import { useAppSelector } from "store";
import util from "utils/utils";
import api from "api";
import toast from "react-hot-toast";
import { datePlusDays } from "./Calendar";

const Settings = ({ challenge, calendar, setCalendar }) => {
  const user = useAppSelector((state) => state.user);
  const canManageChallenge = util.canManageChallenge(user, challenge);
  const challengeId = challenge._id;

  const from = calendar?.start ? new Date(calendar.start) : new Date();
  const nextMonth = new Date(from);
  nextMonth.setMonth(nextMonth.getMonth() + 1);
  const to = calendar?.end ? new Date(calendar.end) : nextMonth;

  // Calculate min and max dates for the date pickers
  const toMinDate = datePlusDays(from, 1);
  const fromMaxDate = datePlusDays(to, -1);

  const setFrom = useCallback(
    (value: string) => {
      api.challenges.updateCalendar(
        challengeId,
        { start: value },
        () => {
          setCalendar((prev) => ({ ...prev, start: value }));
        },
        (error) => {
          toast.error(error.message);
        },
      );
    },
    [challengeId, setCalendar],
  );

  const setTo = useCallback(
    (value: string) => {
      api.challenges.updateCalendar(
        challengeId,
        { end: value },
        () => {
          setCalendar((prev) => ({ ...prev, end: value }));
        },
        (error) => {
          toast.error(error.message);
        },
      );
    },
    [challengeId, setCalendar],
  );

  return (
    <Segment>
      <p>Manage and configure the planner.</p>
      {canManageChallenge ? (
        <Form>
          <Form.Group>
            <Form.Field>
              <label>The calendar will span from:</label>
              <DateInput
                value={from.toISOString().split("T")[0]}
                dateFormat="YYYY-MM-DD"
                onChange={(e, { value }) => setFrom(value)}
                maxDate={fromMaxDate.toISOString().split("T")[0]}
              />
            </Form.Field>

            <Form.Field>
              <label>to:</label>
              <DateInput
                value={to.toISOString().split("T")[0]}
                dateFormat="YYYY-MM-DD"
                onChange={(e, { value }) => setTo(value)}
                minDate={toMinDate.toISOString().split("T")[0]}
              />
            </Form.Field>
          </Form.Group>
        </Form>
      ) : null}
    </Segment>
  );
};

export default Settings;
